import styled from "styled-components";
import {Col} from "react-bootstrap";

export const GSPSSuccessMessage = styled(Col).attrs(() => ({
    className: "text-center alert alert-success m-5",
}))``;
